<template>
  <modal @click-outside-modal="$emit('close')">
    <div class="modal-container">
      <img
        src="@/assets/integrations/kt-logo.svg"
        alt="keeptruckin logo"
      />
      <p class="header">Log in to your account</p>
      <input
        id="email"
        v-model="email"
        class="input-field mb-7 placeholder-gray-400"
        type="text"
        placeholder="Email or Username"
        requried="required"
      />
      <input
        v-model="password"
        class="input-field mb-9 placeholder-gray-400"
        type="password"
        placeholder="Password"
        requried="required"
      />
      <button
        type="button"
        class="btn mb-6"
        @click.prevent="
          $emit('close');
          updateIntegrations('integrations.systems', integration);
        "
      >
        Log in
      </button>
      <p class="password-link mb-4">Forgot your password?</p>
      <p class="account-link">Don't have an account?</p>
      <p class="password-link mb-11">Sign up</p>
      <div class="flex">
        <img
          class="globe"
          src="@/assets/integrations/globe.png"
          alt="globe"
        />
        <p class="lang">EN</p>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
export default {
  name: 'IntegrationLoginModal',
  components: {
    Modal,
  },
  props: {
    visibile: Boolean,
    integration: String,
    updateIntegrations: Function,
  },
  emits: ['close'],
  data() {
    return {
      email: '',
      password: '',
    };
  },
  mounted() {
    const findEmail = document.querySelector(`#email`);
    findEmail.focus();
  },
};
</script>

<style scoped>
p {
  font-family: 'Open Sans', sans-serif;
}

.modal-container {
  padding: 30px 30px 42px;
  background-color: white;
  width: 400px;
  max-width: 95vw;
  border: 0.78px;
  border-radius: 5px;
  box-shadow: 0px 3.88048px 7.76095px rgba(109, 113, 129, 0.14);
  @apply flex flex-col items-center border-light-gray;
}
.input-field {
  width: 100%;
  height: 44px;
  padding: 8px 30px;
  max-height: 44px;
  color: #6d8290;
  border: 1px solid rgba(138, 156, 167, 0.4);
  border-radius: 0.25rem;
  font-family: 'Open Sans', sans-serif;
}

.header {
  @apply mb-6 mt-12 text-2xl;
}

.btn {
  border: 1px solid transparent;
  display: inline-block;
  background-color: #4a88c2;
  border-color: #3d7bb5;
  border-radius: 0.25rem;
  color: white;
  height: 46px;
  font-size: 14px;
  font-weight: 800;
  width: 100%;
}

.password-link {
  font-size: 14px;
  color: #4a88c2;
}

.account-link {
  font-size: 16px;
  color: #787878;
}

.lang {
  color: #353537;
  font-size: 14px;
  margin-left: -2px;
}

.globe {
  height: 18px;
  position: relative;
  top: 2px;
  left: -5px;
}

::placeholder {
  font-family: 'Open Sans', sans-serif;
}

input:focus {
  outline: none;
  border: 1px solid rgba(100, 140, 199);
}
</style>
